module.exports = "#version 300 es\nprecision highp float;\n\nin vec2 fs_UV;\nout vec4 out_Col;\n\nuniform sampler2D u_frame;\nuniform float u_Time;\n\n\nvoid main() {\n\t// TODO: proper tonemapping\n\t// This shader just clamps the input color to the range [0, 1]\n\t// and performs basic gamma correction.\n\t// It does not properly handle HDR values; you must implement that.\n\n\tvec3 color = texture(u_frame, fs_UV).xyz;\n\tcolor = min(vec3(1.0), color);\n\n\t// gamma correction\n\tcolor = pow(color, vec3(1.0 / 2.2));\n\tout_Col = vec4(color, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/tonemap-frag.glsl
// module id = 39
// module chunks = 0